import { levelForXp, loadEconomy } from '@runkr/config/economy'
import type { Levels } from '@runkr/config/economy'
import type { ProfileRow } from './profileApi'

/** D-053's `ProfileView` plus `isGuest` (O-27): what the hub, results and profile screen read. */
export interface ProfileView {
  displayName: string
  level: number
  xpIntoLevel: number
  xpForNext: number
  totalXp: number
  coins: number
  gems: number
  races: number
  wins: number
  finishes: number
  isGuest: boolean
}

export interface WalletView {
  coins: number
  gems: number
}

let cached: Levels | null = null

/** The level curve from `economy.json`, so the client and `record_match` agree (D-038). */
export function economyLevels(): Levels {
  cached ??= loadEconomy().levels
  return cached
}

/** Level and bar from the XP total (`levelForXp`); `profiles.level` is only a cache of it. */
export function toProfileView(row: ProfileRow, levels: Levels = economyLevels()): ProfileView {
  const info = levelForXp(row.xp, levels)
  return {
    displayName: row.displayName,
    level: info.level,
    xpIntoLevel: info.xpIntoLevel,
    xpForNext: info.xpForNext,
    totalXp: row.xp,
    coins: row.coins,
    gems: row.gems,
    races: row.races,
    wins: row.wins,
    finishes: row.finishes,
    isGuest: row.isGuest,
  }
}

/** XP bar fill 0..1 for a running total (full at the top level). */
export function xpFill(totalXp: number, levels: Levels = economyLevels()): number {
  const info = levelForXp(totalXp, levels)
  return info.xpForNext > 0 ? Math.min(1, info.xpIntoLevel / info.xpForNext) : 1
}
